import { Directive } from '@angular/core';

@Directive({
  selector: '[rmsPageLayoutHeader],rms-page-layout-header',
  host: {
    class: 'rms-page-layout-header',
  },
})
export class PageLayoutHeaderDirective {}
